import { defineComponent as _defineComponent } from 'vue'
import BCXSwitch from '@/components/molecules/BCXSwitch.vue';
import { useVModel } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'NewAvailabilitySwitchSection',
  props: {
  labelOn: {
    type: String, default: ''
  },
  labelOff: {
    type: String, default: ''
  },
  isRedWhenOn: Boolean,
  value: Boolean,
  disabled: Boolean
},
  setup(__props) {

const props = __props;



const vmValue = useVModel(props);


return { __sfc: true,props, vmValue, BCXSwitch }
}

})